const React = require("react");

function AbstractSpinnerLoading({ isLoading, color }) {
  let colorClass = "";
  switch (color) {
    case "medgo-blue":
      colorClass = "medgo-blue";
      break;
    case "medgo-grey":
      colorClass = "medgo-grey";
      break;
    case "medgo-white":
      colorClass = "white";
      break;
    case "comet":
      colorClass = "comet";
      break;
    default:
      colorClass = "white";
  }

  return <span className={colorClass}>{isLoading && <i className="fa fa-spinner fa-spin" />}</span>;
}

module.exports = AbstractSpinnerLoading;



// WEBPACK FOOTER //
// ./assets/react/views/abstractPrimitive/AbstractSpinnerLoading.primitive.js